import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Links = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m13.06 8.11 1.41 1.42a7 7 0 0 1 0 9.9l-.35.35a7 7 0 1 1-9.9-9.9l1.42 1.41a5 5 0 1 0 7.07 7.07l.35-.35a5 5 0 0 0 0-7.07l-1.41-1.41 1.41-1.42Zm6.72 6.01-1.42-1.41a5 5 0 1 0-7.07-7.07l-.35.35a5 5 0 0 0 0 7.07l1.41 1.41-1.41 1.42-1.41-1.42a7 7 0 0 1 0-9.9l.35-.35a7 7 0 1 1 9.9 9.9Z"
    />
  </svg>
));
